export function obterListaTipoOperacaoVeicular() {
  return (
    [
      { label: '1 - Venda Concessionária', value: 'CONCESSIONARIA' },
      { label: '2 - Faturamento Direto', value: 'FATURAMENTO' },
      { label: '3 - Venda Direta', value: 'DIRETA' },
      { label: '0 - Outros', value: 'OUTROS' },
    ]
  );
}
